// LUMINA · pages/vajra/TeacherDetailPage.jsx
// Phase 112: Teacher detail — bio + events timeline + offerings CTA

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API, GD, GDL, GDH, BG, TXT, TXT2, EVENT_TYPE_LABEL } from './constants';

export default function TeacherDetailPage({ lang: langProp }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const lang = langProp || localStorage.getItem("lumina_lang") || "zh";
  const L = (zh, en) => lang === "zh" ? zh : en;
  const today = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    setLoading(true);
    fetch(`${API}/vajra/teachers/${id}`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { setTeacher(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{minHeight:"100vh",background:BG,display:"flex",alignItems:"center",justifyContent:"center",color:"#bbb",fontSize:13}}>
      {L("载入中…","Loading…")}
    </div>
  );

  if (!teacher) return (
    <div style={{minHeight:"100vh",background:BG,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:16}}>
      <div style={{color:"#bbb",fontSize:14}}>{L("上师信息未找到","Teacher not found")}</div>
      <button onClick={()=>navigate("/vajra")} style={{padding:"8px 20px",borderRadius:8,background:"transparent",border:`1px solid rgba(212,175,55,0.4)`,color:GD,cursor:"pointer",fontSize:13}}>
        {L("返回首页","Back to Home")}
      </button>
    </div>
  );

  const upcoming = (teacher.events||[]).filter(e => (e.start_date||"9999") >= today);
  const past     = (teacher.events||[]).filter(e => e.start_date && e.start_date < today);

  return (
    <div style={{minHeight:"100vh",background:BG,fontFamily:"'Noto Serif SC','Noto Serif',serif",color:TXT}}>

      {/* ── Back nav ── */}
      <div style={{maxWidth:900,margin:"0 auto",padding:"20px 24px 0"}}>
        <button onClick={()=>navigate(-1)} style={{fontSize:12,color:GD,background:"none",border:"none",cursor:"pointer",padding:0,letterSpacing:.5}}>
          ← {L("返回","Back")}
        </button>
      </div>

      {/* ── Hero: photo + name + title ── */}
      <div style={{maxWidth:900,margin:"0 auto",padding:"32px 24px 40px"}}>
        <div style={{display:"flex",gap:28,alignItems:"flex-start",flexWrap:"wrap"}}>
          {teacher.photo_url ? (
            <img src={teacher.photo_url} alt={teacher.name_zh}
              style={{width:120,height:120,borderRadius:"50%",objectFit:"cover",flexShrink:0,
                border:"3px solid rgba(212,175,55,0.4)",boxShadow:"0 4px 20px rgba(212,175,55,0.2)"}}/>
          ) : (
            <div style={{width:120,height:120,borderRadius:"50%",background:"rgba(212,175,55,0.08)",
              display:"flex",alignItems:"center",justifyContent:"center",fontSize:48,flexShrink:0,
              border:"2px solid rgba(212,175,55,0.2)"}}>☸</div>
          )}
          <div style={{flex:1,minWidth:200}}>
            <div style={{fontSize:28,color:TXT,fontWeight:600,letterSpacing:.5,marginBottom:6}}>
              {lang==="zh" || !teacher.name_en ? teacher.name_zh : teacher.name_en}
            </div>
            {teacher.tradition && (
              <div style={{fontSize:13,color:GD,letterSpacing:1,marginBottom:4}}>
                {teacher.tradition}{teacher.lineage ? ` · ${teacher.lineage}` : ""}
              </div>
            )}
            {/* Offering CTA */}
            <button onClick={()=>navigate("/vajra/offerings")} style={{
              marginTop:12,padding:"9px 22px",
              background:`linear-gradient(135deg,${GD},#A07828)`,
              border:"none",borderRadius:8,color:"#fff",fontSize:12,cursor:"pointer",
              letterSpacing:1,boxShadow:"0 3px 12px rgba(107,79,16,0.25)",
            }}>
              🪔 {L("随喜供养","Make Offering")}
            </button>
          </div>
        </div>
      </div>

      <div style={{maxWidth:900,margin:"0 auto",padding:"0 24px 60px"}}>
        {/* ── Bio ── */}
        {(teacher.bio_zh || teacher.bio_en) && (
          <div style={{marginBottom:48}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,transparent,rgba(184,134,11,0.3))"}}/>
              <div style={{fontSize:11,color:GD,letterSpacing:2,textTransform:"uppercase"}}>{L("简介","Biography")}</div>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,rgba(184,134,11,0.3),transparent)"}}/>
            </div>
            <div style={{fontSize:15,color:TXT,lineHeight:1.9,letterSpacing:.3}}>
              {lang==="zh" ? (teacher.bio_zh||teacher.bio_en) : (teacher.bio_en||teacher.bio_zh)}
            </div>
          </div>
        )}

        {/* ── Upcoming Events ── */}
        {upcoming.length > 0 && (
          <div style={{marginBottom:40}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,transparent,rgba(184,134,11,0.3))"}}/>
              <div style={{fontSize:11,color:GD,letterSpacing:2,textTransform:"uppercase"}}>{L("近期法讯","Upcoming Events")}</div>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,rgba(184,134,11,0.3),transparent)"}}/>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {upcoming.map(ev => (
                <div key={ev.id} onClick={()=>navigate(`/events/${ev.slug||ev.id}`)} style={{
                  padding:"14px 18px",borderRadius:10,cursor:"pointer",
                  background:"rgba(212,175,55,0.04)",border:"1px solid rgba(212,175,55,0.2)",
                  transition:"transform .2s,box-shadow .2s",
                }}
                onMouseOver={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 4px 16px rgba(212,175,55,0.12)";}}
                onMouseOut={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="none";}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <div style={{fontSize:14,color:TXT,fontWeight:500}}>{lang==="zh"?(ev.title_zh||ev.title_en):(ev.title_en||ev.title_zh)}</div>
                    <span style={{fontSize:11,color:GD}}>{ev.start_date}</span>
                  </div>
                  {ev.location&&<div style={{fontSize:11,color:TXT2,marginTop:4}}>📍 {ev.location}</div>}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Past Events Timeline ── */}
        {past.length > 0 && (
          <div style={{marginBottom:40}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,transparent,rgba(184,134,11,0.3))"}}/>
              <div style={{fontSize:11,color:GD,letterSpacing:2,textTransform:"uppercase"}}>{L("往期法会","Past Events")}</div>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,rgba(184,134,11,0.3),transparent)"}}/>
            </div>
            <div style={{borderLeft:"2px solid rgba(212,175,55,0.2)",paddingLeft:20,display:"flex",flexDirection:"column",gap:14}}>
              {past.slice(0,10).map(ev => (
                <div key={ev.id} style={{position:"relative"}}>
                  <div style={{position:"absolute",left:-25,top:4,width:8,height:8,borderRadius:"50%",background:GDH,border:"2px solid rgba(212,175,55,0.4)"}}/>
                  <div style={{fontSize:13,color:TXT}}>{lang==="zh"?(ev.title_zh||ev.title_en):(ev.title_en||ev.title_zh)}</div>
                  <div style={{fontSize:11,color:TXT2,marginTop:2}}>{ev.start_date} · {EVENT_TYPE_LABEL[ev.event_type]||ev.event_type}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Related Teachings ── */}
        {(teacher.teachings||[]).length > 0 && (
          <div>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,transparent,rgba(184,134,11,0.3))"}}/>
              <div style={{fontSize:11,color:GD,letterSpacing:2,textTransform:"uppercase"}}>{L("相关教法","Related Teachings")}</div>
              <div style={{height:1,flex:1,background:"linear-gradient(90deg,rgba(184,134,11,0.3),transparent)"}}/>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",gap:10}}>
              {teacher.teachings.map(th => (
                <div key={th.id} onClick={()=>navigate(`/teaching/${th.id}`)} style={{
                  padding:"8px 16px",borderRadius:8,cursor:"pointer",fontSize:12,color:GD,
                  background:"rgba(212,175,55,0.06)",border:"1px solid rgba(212,175,55,0.2)",
                  transition:"background .15s",
                }}
                onMouseOver={e=>e.currentTarget.style.background="rgba(212,175,55,0.12)"}
                onMouseOut={e=>e.currentTarget.style.background="rgba(212,175,55,0.06)"}>
                  {th.title_zh}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
